<template>
  <div class="container" id="goods-edit">
    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <el-breadcrumb separator="">
        <el-breadcrumb-item>
          <div class="div1">矩阵管理</div>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <div class="div2">客服管理</div>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content">
      <h2>客服管理</h2>
      <el-form label-width="120px" class="info-form">
        <el-form-item label="客服名称">
          <el-input
            placeholder="请输入客服名称"
            v-model="name"
            style="width: 30%"
            maxlength="10"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input
            placeholder="请输入联系电话"
            v-model="contact"
            style="width: 30%"
          ></el-input>
        </el-form-item>
        <el-form-item> </el-form-item>
        <el-form-item label="二维码">
          <div>
            <headerPicture
              @getUrl="getImage($event)"
              :qrCodeUrl="qrCodeUrl"
            ></headerPicture>
          </div>

          <span>请上传二维码</span>
        </el-form-item>
      </el-form>
      <div style="width: 30%; text-align: center; padding-bottom: 20px">
        <el-button type="primary" @click="submit()">确认</el-button>
        <el-button @click="back">返回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import headerPicture from '@/components/upload/headerPicture.vue'
export default {
  components: {
    headerPicture
  },
  data () {
    return {
      name: '---',
      qrCodeUrl: '',
      contact: '',
      dialogUser: false,
      tableData: [
        {}, {}, {}
      ]
    }
  },
  created () {
    this.getConfig()
  },
  methods: {
    getConfig () {
      this.$api.getCustomerServiceConfig({}).then(res => {
        if (res.code == 0) {
          this.name = res.data.name
          this.contact = res.data.contact
          this.qrCodeUrl = res.data.qrCodeUrl
        }
      })
    },
    getImage (val) {
      console.log(val)
      this.qrCodeUrl = val
    },
    back () {
      this.$router.go(-1)
    },
    submit () {
      let data = {
        name: this.name,
        contact: this.contact,
        qrCodeUrl: this.qrCodeUrl
      }
      this.$api.editCustomerServiceConfig(data).then(res => {
        if (res.code == 0) {
          this.$message({
            type: 'success',
            message: '更改成功'
          });
          this.getConfig()
        }
      })
    }
  }
}
</script>
<style scoped>
.div1 {
  margin-left: -16px;
  background: url(../../assets/breadcrumb2.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #2d7edf;
}

.div2 {
  margin-left: -16px;
  background: url(../../assets/breadcrumb1.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #fff;
}
.dialog-search {
  display: flex;
  width: 46%;
  justify-content: space-between;
  margin-top: 10px;
  margin-left: 10px;
}
</style>

